window.addEventListener( 'DOMContentLoaded', function () {
    const paramHead = document.querySelectorAll( '.p-post-table__labels' );
    const tableParam = document.querySelector( '.p-post-table__info-wrap' ) || false;

    if ( tableParam ) {
        // 横幅を取得
        const tableParamWidth = tableParam.clientWidth;

        paramHead.forEach( function( item ) {
            item.style.width = tableParamWidth + 'px';

            // ラベルの高さを取得
            const labelHeight = item.clientHeight;
            // // ラベル親要素「.p-post-table」を取得
            // const tableParamParent = item.closest( '.p-post-table' );
            // // ラベル親要素「.p-post-table」にラベルの高さ分のマージンを追加
            // tableParamParent.style.marginTop = labelHeight + 52 + 'px';
        } );
    }

    this.window.addEventListener( 'resize', function () {
        const tableParamWidth = tableParam.clientWidth;

        paramHead.forEach( function( item ) {
            item.style.width = tableParamWidth + 'px';
        } );
    } );


    const catSection = document.querySelectorAll( '.p-category__item' );
    if ( catSection.length ) {
        catSection.forEach( function( catSection ) {
            const posts = catSection.querySelectorAll( '.p-post' );
            if ( posts.length ) {
                posts.forEach( function( post ) {
                    const tableItems = post.querySelectorAll( '.p-post-table__item' );
                    if ( ! tableItems.length ) {
                        post.style.display = 'none';
                    }
                } );
            }

            // .p-post がすべて display none の場合は .p-category__item も非表示
            const postsAfter = catSection.querySelectorAll( '.p-post' );
            let count = 0;
            postsAfter.forEach( function( post ) {
                if ( post.style.display == 'none' ) {
                    count++;
                }
            } );
            if ( count == postsAfter.length ) {
                catSection.style.display = 'none';
            }
        } );
    }

    const select = document.querySelectorAll( '.js-select' );
    if ( select.length ) {
        select.forEach( item => {
            const options = item.querySelectorAll( 'option' );
            // 選択肢が2つ以下の場合は非表示
            if ( options.length <= 1 ) {
                item.style.display = 'none';
                if ( item.getAttribute( 'name' ) == 'prod_name' ) {
                    const form = item.closest( '.p-category__form' );
                    const title = form.querySelector( '.js-select-title' );
                    title.style.display = 'none';
                }
            }
        } );

        select.forEach( item => {
            // 全て display none の場合はform毎非表示
            const form = item.closest( '.p-category__form' );
            const select = form.querySelectorAll( '.js-select' );
            let count = 0;
            select.forEach( item => {
                if ( item.style.display == 'none' ) {
                    count++;
                }
            } );
            if ( count == select.length ) {
                form.style.display = 'none';
            }
        } );
    }

    /**
     * select[name="prod_name"] の 空のoptionをPCスマホで着替える
     */
    let windowWidth = window.innerWidth;
    const selectProdName = document.querySelector( 'select[name="prod_name"]' );
    if ( selectProdName ) {
        const options = selectProdName.querySelectorAll( 'option' );
        if ( options.length > 1 ) {
            if ( windowWidth <= 767 ) {
                selectProdName.options[0].text = '製品名で絞り込む';
            } else {
                selectProdName.options[0].text = '製品名を選んでください';
            }
        }
    }

    this.window.addEventListener( 'resize', function () {
        windowWidth = window.innerWidth;
        if ( selectProdName ) {
            const options = selectProdName.querySelectorAll( 'option' );
            if ( options.length > 1 ) {
                if ( windowWidth <= 767 ) {
                    selectProdName.options[0].text = '製品名で絞り込む';
                } else {
                    selectProdName.options[0].text = '製品名を選んでください';
                }
            }
        }
    } );

    /**
     * 「.p-post-table__labels」の高さが53px以上の場合、「.p-post-table」にマージンを追加
     * リサイズ時にも対応（979px 〜）
     */
    const tables = document.querySelectorAll( '.p-post-table' );
    if ( tables.length ) {
        tables.forEach( function( item ) {
            const label = document.querySelector( '.p-post-table__labels' );
            if ( label.clientHeight >= 53 ) {
                item.style.marginTop = label.clientHeight + 'px';
            }
        } );

        this.window.addEventListener( 'resize', function () {
            tables.forEach( function( item ) {
                if ( window.innerWidth >= 980 ) {
                    const label = document.querySelector( '.p-post-table__labels' );
                    if ( label.clientHeight >= 53 ) {
                        item.style.marginTop = label.clientHeight + 'px';
                    }
                } else {
                    item.style.marginTop = '15px';
                }
            } );
        } );
    }

    /**
     * サブカテゴリのリストについて、空白の箇所に空のaタグを追加する
     * min-width: 1024px の場合：3列
     * max-width: 1023px の場合：2列
     */
    const subcats = document.querySelector( '.p-category__subcat-list' ) || false;
    if ( subcats ) {
        const subcatItems = subcats.querySelectorAll( 'a' );
        const subcatItemsLength = subcatItems.length;
        const subcatItemsLengthMod3 = subcatItemsLength % 3;
        const subcatItemsLengthMod2 = subcatItemsLength % 2;
        const subcatItemsLengthMod1 = subcatItemsLength % 1;

        if ( window.innerWidth >= 1024 ) {
            if ( subcatItemsLengthMod3 == 1 ) {
                subcats.insertAdjacentHTML( 'beforeend', '<a class="is--empty"></a><a class="is--empty"></a>' );
            } else if ( subcatItemsLengthMod3 == 2 ) {
                subcats.insertAdjacentHTML( 'beforeend', '<a class="is--empty"></a>' );
            }
        } else {
            if ( subcatItemsLengthMod2 == 1 ) {
                subcats.insertAdjacentHTML( 'beforeend', '<a class="is--empty"></a>' );
            }
        }

        // リサイズ時にも対応
        // 不要になったaタグを削除
        this.window.addEventListener( 'resize', function () {
            $( '.is--empty' ).remove();

            const subcatItems = subcats.querySelectorAll( 'a' );
            const subcatItemsLength = subcatItems.length;
            const subcatItemsLengthMod3 = subcatItemsLength % 3;
            const subcatItemsLengthMod2 = subcatItemsLength % 2;
            const subcatItemsLengthMod1 = subcatItemsLength % 1;


            if ( window.innerWidth >= 1024 ) {
                if ( subcatItemsLengthMod3 == 1 ) {
                    subcats.insertAdjacentHTML( 'beforeend', '<a class="is--empty"></a><a class="is--empty"></a>' );
                } else if ( subcatItemsLengthMod3 == 2 ) {
                    subcats.insertAdjacentHTML( 'beforeend', '<a class="is--empty"></a>' );
                }
            } else {
                if ( subcatItemsLengthMod2 == 1 ) {
                    subcats.insertAdjacentHTML( 'beforeend', '<a class="is--empty"></a>' );
                }
            }
        } );
    }
} );
